export const convertToCurrencyFormat = (value, currency = '') => {
  if (!value && value !== 0) {
    return ''
  }

  return currency + Number(value).toLocaleString()
}
